
import WebService from "../../WebService"

const Speaker = {
    gets(params) {
        
        return WebService.get("/console/contest/speakers?" + params)
    },
    get(id, e = null) {
        return WebService.get("/console/contest/speakers/" + id + '?e=' + e)
    },
    create(data) {
        return WebService.post("/console/contest/speakers", data)
    },
    update(data) {
        return WebService.post("/console/contest/speakers/" + data.speaker_id, data)
    },
    upload(speaker_id, data) {
        return WebService.post("/console/contest/speakers/" + speaker_id, data)
    }
}
export default Speaker